import { UserType } from '@/api/login/types';
import { useUserStore } from '@/store/modules/user';
import { useAppStore } from '@/store/modules/app';
import { usePermissionStore } from '@/store/modules/permission';
import { useRouter } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import router from '@/router/index';

export default function useSetRoleData() {
  const appStore = useAppStore();
  const userStore = useUserStore();
  const permissionStore = usePermissionStore();

  const { addRoute } = useRouter();

  //设置角色路由权限
  const setRoleRouters = async (roleRouters: string[] | AppCustomRouteRecordRaw[]) => {
    try {
      userStore.setRoleRouters(roleRouters);
      appStore.getDynamicRouter && appStore.getServerDynamicRouter
        ? await permissionStore.generateRoutes('server', roleRouters).catch(() => {})
        : await permissionStore.generateRoutes('frontEnd', roleRouters).catch(() => {});

      permissionStore.getAddRouters.forEach((route) => {
        addRoute(route as RouteRecordRaw); // 动态添加可访问路由表
      });
      permissionStore.setIsAddRouters(true);
      return true;
    } catch (error) {
      console.log(error);
    }
  };

  //设置角色用户信息
  const setRoleUserInfo = (userInfo: UserType) => {
    userStore.setUserInfo(userInfo);
  };

  const setRoleData = (userInfo: UserType, roleRouters: string[] | AppCustomRouteRecordRaw[]) => {
    userStore.setLoginInfo(undefined);
    const routers = roleRouters;
    // 获取当前路由配置对象
    const routerList = router.getRoutes();
    // 遍历路由配置对象
    routerList.forEach((route) => {
      // 判断没有的资源id的属性，添加公共资源id
      if (route.meta.resourceId === undefined) {
        // 添加新的属性到 meta 中
        route.meta.resourceId = userInfo.publicResourceId;
      }
    });
    setRoleRouters(routers);
    setRoleUserInfo(userInfo);
  };
  return {
    setRoleRouters,
    setRoleUserInfo,
    setRoleData,
  };
}
